import type { FC } from 'react';
import type { Agent, DeviceType } from '../agent';
import { hasAreaSearchParams } from '../area';
import { useAreaContent } from '../hooks/useAreaContent';
import { useSearchParams } from '../hooks/useSearchParams';
import { MeglerpromoPanel } from './MeglerpromoPanel';
import { PristipsFormPanel } from './PristipsFormPanel';

export type AppProps = {
    areaContentUrl: string;
    selectedAdIdsUrl: string;
    agents: Agent[];
    squareMeterPrice: number | null;
    deviceType: DeviceType;
    hasArea: boolean;
    /** The server's content call failed, so `agents` is empty for lack of an answer, not of agents. */
    contentFailed: boolean;
    subVertical: string;
};

export const App: FC<AppProps> = ({
    areaContentUrl,
    selectedAdIdsUrl,
    agents: initialAgents,
    squareMeterPrice: initialSquareMeterPrice,
    deviceType,
    hasArea: initialHasArea,
    contentFailed,
    subVertical,
}) => {
    const searchParams = useSearchParams();
    const { agents, squareMeterPrice, isError } = useAreaContent(
        areaContentUrl,
        { agents: initialAgents, squareMeterPrice: initialSquareMeterPrice },
        contentFailed,
        subVertical,
    );

    const hasArea = typeof window === 'undefined' ? initialHasArea : hasAreaSearchParams(searchParams);

    if (!hasArea) return <PristipsFormPanel deviceType={deviceType} selectedAdIdsUrl={selectedAdIdsUrl} />;

    if (isError || agents.length === 0) return null;

    return (
        <MeglerpromoPanel
            agents={agents}
            squareMeterPrice={squareMeterPrice}
            deviceType={deviceType}
            searchParams={searchParams}
        />
    );
};
